<template>
    <v-app
        :dark="darkMode"
        id="inspire"
        :class="[
            {
                'box-layout': boxLayout,
                'collapse-sidebar': collapseSidebar,
                'rtl-layout': rtlLayout,
            },
        ]"
    >
        <router-view />
		<AppConfirmationDialog />
    </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import AppConfirmationDialog from "@/components/AppConfirmationDialog";

export default {
    name: "default",
	components: {
		AppConfirmationDialog,
	},
    computed: {
        ...mapGetters( [ "darkMode", "collapseSidebar", "boxLayout", "rtlLayout", ] ),
    },
};
</script>



// WEBPACK FOOTER //
// src/layouts/default.vue